import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Nav } from "react-bootstrap";
import "./Nav.css";
import NavBarLogoFinal from "../../media/NavBarLogoFinal.svg";
import { getClientByEmail } from "../../services/clientService";
import { useAuth } from "../../auth";

interface ClientNavProps {
  isMobile: boolean;
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  handleLogout: () => void;
}

const ClientNav: React.FC<ClientNavProps> = ({
  isMobile,
  isSidebarOpen,
  toggleSidebar,
  handleLogout,
}) => {
  // const [showReferenceFormLink, setShowReferenceFormLink] = useState(false);
  // const [showSubscriptionLink, setShowSubscriptionLink] = useState(false);
  const { decodeToken } = useAuth();

  useEffect(() => {
    const fetchFormStatus = async () => {
      try {
        const email = decodeToken(localStorage.getItem("token") || "");
        const clientIDString = localStorage.getItem("clientID");
        const clientID = clientIDString ? parseInt(clientIDString, 10) : 0;
        const client = await getClientByEmail(email, clientID);

        // const { isReferenceSelected, isSubscriptionSelected } =
        //   await checkForAvailablePages(client.clientID);

        // setShowReferenceFormLink(isReferenceSelected);
        // setShowSubscriptionLink(isSubscriptionSelected);
      } catch (error) {
        console.error("Error checking form status:", error);
      }
    };

    fetchFormStatus();
  }, [decodeToken]);

  return (
    <div className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
      {isMobile && (
        <div className="mobile-header">
          <div className="hamburger-button" onClick={toggleSidebar}>
            &#9776;
          </div>
          {isSidebarOpen && (
            <img
              src={NavBarLogoFinal}
              alt="Oxford Logo"
              className="sidebar-logo"
              // onClick={() =>
              //   window.open("https://www.oxforddoc.com/", "_blank")
              // }
            />
          )}
        </div>
      )}

      {isSidebarOpen && (
        <>
          {!isMobile && (
            <div className="sidebar-header">
              <img
                src={NavBarLogoFinal}
                alt="Oxford Logo"
                className="sidebar-logo"
                // onClick={() =>
                //   window.open("https://www.oxforddoc.com/", "_blank")
                // }
              />
            </div>
          )}
          <Nav className="flex-column">
            <Nav.Item>
              <Nav.Link as={Link} to="/client/current-orders">
                <i className="bi bi-people-fill nav-icon" />
                Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link as={Link} to="/client/profile">
                <i className=" bi bi-pen-fill nav-icon" />
                Profile
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link as={Link} to="/client/position-codes">
                <i className="bi bi-clipboard-fill nav-icon" />
                Position Codes
              </Nav.Link>
            </Nav.Item>

            {/* {showReferenceFormLink && ( */}
            <Nav.Item>
              <Nav.Link as={Link} to="/client/questionnaires">
                <i className="bi bi-paperclip nav-icon" />
                Questionnaires
              </Nav.Link>
            </Nav.Item>
            {/* )} */}

            <Nav.Item>
              <Nav.Link as={Link} to="/client/required-forms">
                <i className="bi bi-folder2-open nav-icon"></i>
                Required Forms
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link as={Link} to="/client/past-candidates">
                <i className="bi bi-briefcase-fill nav-icon" />
                Completed Candidates
              </Nav.Link>
            </Nav.Item>
            {/* 
            {showSubscriptionLink && ( */}
            <Nav.Item>
              <Nav.Link as={Link} to="/client/subscriptions">
                <i className="bi bi-display nav-icon" />
                Subscription Candidates
              </Nav.Link>
            </Nav.Item>
            {/* )} */}

            <Nav.Item>
              <Button
                onClick={handleLogout}
                variant="outline-light"
                className="signout-button"
              >
                Sign Out <i className="bi bi-box-arrow-right sign-out-icon"></i>
              </Button>
            </Nav.Item>

            <Nav.Item className="mt-auto">
              <Button
                onClick={() =>
                  window.open("/help", "_blank", "noopener,noreferrer")
                }
                variant="outline-light"
                className="signout-button"
              >
                Contact Us/Need Help{" "}
                <i className="bi bi-question-circle btn-icon"></i>
              </Button>

              <div className="btn-contact">
                <a href="/privacy-policy" className="btn-contact-field">
                  Privacy Policy
                </a>
              </div>
            </Nav.Item>
          </Nav>
        </>
      )}
    </div>
  );
};

export default ClientNav;
